import { render, staticRenderFns } from "./MobileFeed.vue?vue&type=template&id=614b1b28&scoped=true&"
import script from "./MobileFeed.vue?vue&type=script&lang=js&"
export * from "./MobileFeed.vue?vue&type=script&lang=js&"
import style0 from "./MobileFeed.vue?vue&type=style&index=0&id=614b1b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614b1b28",
  null
  
)

export default component.exports